import React from 'react';
import Icon from '@icon-park/react/es/all';
import Container from '@/components/container';
import FlexRow from '@/components/flex-row';
import FlexCol from '@/components/flex-col';
import Hyperlink from '@/components/hyperlink';
import Linkedin from '@/icons/linkedin';
import links from '@/constants/links.json';
import './hero.style.scss';
import { ClassNames } from '@/modules/classNames';



function HeroSection() {
	const CN = new ClassNames('hero');

	return (
		<section className={CN.generate('')}>
			<span className={CN.generate('circle', ['one'])}/>
			<span className={CN.generate('circle', ['two'])}/>
			<Container>
				<FlexRow>
					<FlexCol xs={24} sm={24} md={18}>
						<div className={CN.generate('content')}>
							<h1>Hi, 👋🏻<br/> <i>I'm</i> Karon</h1>
							<p>
								I am a software engineer with 10 years of experience designing and delivering products that generate measurable business value. Throughout my career, I have led initiatives from initial concept through full production deployment, collaborating closely with both technical stakeholders and cross-functional partners. I am motivated by tackling complex engineering challenges, optimizing development workflows, and enabling teams to consistently ship high-quality solutions on schedule. My core technical strengths include database architecture and administration, and I regularly work with technologies such as Golang, Python, Node.js, and React.
							</p>
							<div className={CN.generate('actions')}>
								<Hyperlink
									variant={'primary-light'}
									to={'Karon.pdf'}
									target="_blank"
									data-tooltip-id="tooltip-area"
									data-tooltip-content="LinkedIn"
									data-tooltip-place="bottom"
								>
									<Icon type={'DownloadTwo'} size={24}/> Download CV
								</Hyperlink>
								<Hyperlink
									icon={true}
									variant={'linear-light'}
									to={links["social"]["linkedin"]}
									target="_blank"
									data-tooltip-id="tooltip-area"
									data-tooltip-content="LinkedIn"
									data-tooltip-place="bottom"
								>
									<Linkedin size={24}/>
								</Hyperlink>
								<Hyperlink
									icon={true}
									variant={'linear-light'}
									to={links["social"]["github"]}
									target="_blank"
									data-tooltip-id="tooltip-area"
									data-tooltip-content="Github"
									data-tooltip-place="bottom"
								>
									<Icon type="Github" theme="filled" size={24}/>
								</Hyperlink>
							</div>
						</div>
					</FlexCol>
				</FlexRow>
			</Container>
			<span className={'hero-mouse'}/>
		</section>
	);
}

export default HeroSection;
